var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleDent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{mix-blend-mode:screen;}.cls-1,.cls-3{fill:#aa8fc2;}.cls-3{opacity:0;}.cls-4{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.08,34.67H32.51c-13.16,0-23.92,10.76-23.92,23.92v45.57c0,13.16,10.76,23.92,23.92,23.92h45.57c13.16,0,23.92-10.76,23.92-23.92V58.6c0-13.16-10.76-23.92-23.92-23.92Zm-6.33,54.73c0,4.64-3.79,8.43-8.43,8.43h-16.06c-4.64,0-8.43-3.79-8.43-8.43v-16.06c0-4.64,3.79-8.43,8.43-8.43h16.06c4.64,0,8.43,3.79,8.43,8.43v16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.27,61.53h-50.93c-14.71,0-26.74,12.03-26.74,26.74v50.93c0,14.71,12.03,26.74,26.74,26.74h50.93c14.71,0,26.74-12.03,26.74-26.74v-50.93c0-14.71-12.03-26.74-26.74-26.74Zm-7.07,61.18c0,5.18-4.24,9.42-9.42,9.42h-17.95c-5.18,0-9.42-4.24-9.42-9.42v-17.95c0-5.18,4.24-9.42,9.42-9.42h17.95c5.18,0,9.42,4.24,9.42,9.42v17.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.67,113.73h-29.84c-8.62,0-15.67,7.05-15.67,15.67v29.84c0,8.62,7.05,15.67,15.67,15.67h29.84c8.62,0,15.67-7.05,15.67-15.67v-29.84c0-8.62-7.05-15.67-15.67-15.67Zm-4.14,35.85c0,3.04-2.48,5.52-5.52,5.52h-10.52c-3.04,0-5.52-2.48-5.52-5.52v-10.52c0-3.04,2.48-5.52,5.52-5.52h10.52c3.04,0,5.52,2.48,5.52,5.52v10.52Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDent2);
export default __webpack_public_path__ + "static/media/title-dent-2.36b98923d024ecf4a48a1ba74d267e73.svg";
export { ForwardRef as ReactComponent };